import receptionistAvatar from 'dashboard/assets/images/assistents/receptionist.png';
import leadQualificationAvatar from 'dashboard/assets/images/assistents/lead_qualification.png';
import scheduleReviewAvatar from 'dashboard/assets/images/assistents/schedule_review.png';
import researchAvatar from 'dashboard/assets/images/assistents/research.png';

import receptionistInstructions from './templates/receptionist.instructions';
import leadQualificationInstructions from './templates/lead_qualification.instructions';
import scheduleReviewInstructions from './templates/schedule_review.instructions';
import researchInstructions from './templates/research.instructions';

export default [
  {
    id: 'receptionist',
    avatar: receptionistAvatar,
    name: 'Recepcionista',
    category: 'Atendimento · triagem',
    description:
      'Entende a intenção do cliente e direciona para o departamento certo.<br><ul><li>Identifica o motivo do contato</li><li>Transfere para a fila correta</li><li>Responde dúvidas frequentes</li></ul>',
    model: 'gpt-6-luna',
    instructions: receptionistInstructions,
    resolution_rules: [
      'sempre que tiver sinais claros que é um spam e não cliente real',
      'sempre que houver sinais claros de engano do cliente',
    ],
    handoff_rules: [
      'quando conseguir confirmar o departamento de interesse do cliente',
      'quando houver sinais claros de stress do cliente',
    ],
    faqs: [
      {
        question: 'endereço da loja',
        answer: 'Rua XPTO N° 100, Bairro Gertrudes',
      },
      {
        question: 'Horário de funcionamento',
        answer:
          'De segunda a sexta, das 08h até as 18h. Sábado das 09h até as 13h.',
      },
    ],
    macros: [],
    resume_instructions:
      'Faça um resumo detalhado em formato de tópicos sobre o interesse do cliente',
  },
  {
    id: 'lead_qualification',
    avatar: leadQualificationAvatar,
    name: 'Qualificação de leads',
    category: 'Vendas - SDR',
    description:
      'Pré-qualifica interessados em novos e seminovos antes do vendedor.<br><ul><li>Coleta modelo, prazo e forma de pagamento</li><li>Avalia troca na negociação</li><li>Entrega o lead preenchido</li></ul>',
    model: 'gpt-6-luna',
    instructions: leadQualificationInstructions,
    resolution_rules: [
      'sempre que tiver sinais claros que é um spam e não cliente real',
      'sempre que houver sinais claros de engano do cliente',
    ],
    handoff_rules: [
      'quando o cliente estiver minimamente qualificado para o comercial',
      'quando o departamento de interesse for diferente de novos e seminovos',
      'quando o cliente quiser receber uma proposta comercial detalhada',
      'quando o cliente demonstrar sinais de stress',
      'quando o cliente solicitar ser atendido por humano',
    ],
    faqs: [
      {
        question: 'endereço da loja',
        answer: 'Rua XPTO N° 100, Bairro Gertrudes',
      },
      {
        question: 'Horário de funcionamento',
        answer:
          'De segunda a sexta, das 08h até as 18h. Sábado das 09h até as 13h.',
      },
    ],
    macros: [],
    resume_instructions:
      'Faça um resumo detalhado em formato de tópicos sobre o interesse do cliente',
  },
  {
    id: 'schedule_review',
    avatar: scheduleReviewAvatar,
    name: 'Agendamento Revisão',
    category: 'Pós vendas - Agendamento',
    description:
      'Marca revisões e manutenções direto na agenda da oficina.<br><ul><li>Consulta horários disponíveis</li><li>Coleta informações importantes para agendamento</li><li>Confirma e lembra o cliente</li></ul>',
    model: 'gpt-6-luna',
    instructions: scheduleReviewInstructions,
    resolution_rules: [
      'sempre que tiver sinais claros que é um spam e não cliente real',
      'sempre que houver sinais claros de engano do cliente',
    ],
    handoff_rules: [
      'quando o cliente quiser receber uma proposta comercial detalhada',
      'quando o cliente demonstrar sinais de stress',
      'quando o cliente solicitar ser atendido por humano',
      'quando soubermos a data desejada para agendamento do cliente',
    ],
    faqs: [
      {
        question: 'endereço da loja',
        answer: 'Rua XPTO N° 100, Bairro Gertrudes',
      },
      {
        question: 'Horário de funcionamento',
        answer:
          'De segunda a sexta, das 08h até as 18h. Sábado das 09h até as 13h.',
      },
    ],
    macros: [],
    resume_instructions:
      'Demonstre a data e local de interesse do agendamento do cliente assim como possiveis observações feitas para agendamento',
  },
  {
    id: 'research',
    avatar: researchAvatar,
    name: 'Pesquisa',
    category: 'Pós-venda · CSAT',
    description:
      'Faz pesquisa de satisfação do cliente pós passagem pela oficina.<br><ul><li>Solicita avaliação do cliente</li><li>Marca como promotor ou detrator</li><li>Coleta verbalização de problemas</li></ul>',
    model: 'gpt-6-luna',
    instructions: researchInstructions,
    resolution_rules: [
      'sempre que tiver sinais claros que é um spam e não cliente real',
      'sempre que houver sinais claros de engano do cliente',
    ],
    handoff_rules: ['Quando obtermos a nota CSAT da pesquisa'],
    faqs: [
      {
        question: 'endereço da loja',
        answer: 'Rua XPTO N° 100, Bairro Gertrudes',
      },
      {
        question: 'Horário de funcionamento',
        answer:
          'De segunda a sexta, das 08h até as 18h. Sábado das 09h até as 13h.',
      },
    ],
    macros: [],
    resume_instructions: 'Nota e verbalização do cliente',
  },
];
